import { ISelectValue } from 'constants/globalTypes'
import { IUnit, IUnitOption } from 'types/fields.interface'
import { COMPONENT_DIMENSION, UnitDimension } from 'types/unitsEnums.interface'

export const parseUnits = (data: any, dimension?: UnitDimension): IUnitOption[] => {
  const items: IUnit[] = Array.isArray(data) ? data : data?.data ?? []
  return items
    .filter((item) => dimension == null || item.dimension === dimension)
    .map((item) => ({ label: item.name, value: item.id, dimension: item.dimension }))
}

export const parseCapacityUnits = (data: any) => parseUnits(data, UnitDimension.Capacity)

export const parseProgressSourceFields = (data: any, dimension?: UnitDimension): ISelectValue[] => {
  if (dimension == null) return []
  const items = Array.isArray(data) ? data : data?.data ?? []
  return items
    .filter((item) => item.unit?.dimension === dimension)
    .map((item) => ({ label: item.name, value: item.id }))
}

export const isMeasuredComponent = (component: number) => COMPONENT_DIMENSION[component] != null

export const unitSuffix = (unitName?: string | null) => (unitName ? ` (${unitName})` : '')
